import { useContext, useState } from 'react';
import authContext from '../../context/auth/authContext';
import { ModalReporteMovs } from './ModalReporteMovs';
//import { BalanceActions } from '../../presentation/redux/actions/BalanceActions';

export function ReporteMovs() {
  const [isOpenReport, setIsOpenReport] = useState(false);
  const AuthContext = useContext(authContext);
  const { token } = AuthContext;


  const handleOpen = (mt: string) => {
    //uiLOadActive
    setIsOpenReport(!isOpenReport);
  }

  return (
    <>
      <div className="row  cardNeu  mx-1 p-3">
        <div className="col">
          <div className="row">
            <div className="col">
              <h4 className="lvender text-center pt-3 pb-2 ">Reportes</h4>
            </div>
          </div>
          <div className="row">
            <button type="button" onClick={() => handleOpen('')}
              className="btn btnPrimary btn-transparent">Reporte Comisiones Pago de Recaudos</button>
          </div>
        </div>
      </div>
      <ModalReporteMovs
        isOpen={isOpenReport}
        toggle={setIsOpenReport}
        token={token}
      />
    </>
  );
}